const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Cooperators/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Cooperators/Search')

export default [
  {
    path: 'cooperators/create',
    name: 'CooperatorsCreate',
    component: Single,
    meta: {
      title: 'Adicionar Colaborador',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'cooperators',
        action: 'create'
      }
    }
  },
  {
    path: 'cooperators/:id',
    name: 'CooperatorsEdit',
    component: Single,
    meta: {
      title: 'Editar Colaborador',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'cooperators',
        action: 'read'
      }
    }
  },
  {
    path: 'cooperators',
    name: 'CooperatorsSearch',
    component: Search,
    meta: {
      title: 'Colaboradores',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'cooperators',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/cooperators.js